import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { CATEGORIES, FALLBACK_IMG, filterShowcase, REVEAL } from "@/lib/site";

export const Categories = () => (
  <section id="products" className="py-20 sm:py-28">
    <div className="section-shell">
      <div className="max-w-2xl">
        <motion.p variants={REVEAL} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }} className="eyebrow">
          02 / Collections
        </motion.p>
        <motion.h2
          variants={REVEAL} custom={1} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }}
          className="mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight text-walnut"
        >
          Curated For Every <span className="italic text-teak">Living Space</span>
        </motion.h2>
        <motion.p
          variants={REVEAL} custom={2} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }}
          className="mt-4 text-base text-stone-600 leading-relaxed"
        >
          Eight specialised furniture departments, hand-built in our Mumbai workshops
          for homes across Mumbai, Navi Mumbai and Thane.
        </motion.p>
      </div>

      <div data-testid="product-categories-grid" className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-5">
        {CATEGORIES.map((cat, i) => (
          <motion.article
            key={cat.id}
            data-testid={`category-card-${cat.id}`}
            variants={REVEAL}
            custom={i % 3}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-60px" }}
            className={`group relative overflow-hidden rounded-2xl border border-[#E7DFD5] bg-white ${
              i < 6 ? "lg:col-span-4" : "lg:col-span-6"
            } transition-shadow duration-500 hover:shadow-[0_24px_60px_-24px_rgba(46,28,20,0.35)]`}
          >
            <div className="relative aspect-[16/10] overflow-hidden bg-sandsubtle">
              <img
                src={cat.image}
                onError={(e) => { e.currentTarget.src = FALLBACK_IMG; }}
                alt={`${cat.name} — wooden furniture in Mumbai`}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <span className="absolute left-4 top-4 rounded-full bg-noir/70 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-brasslight backdrop-blur">
                {String(i + 1).padStart(2, "0")}
              </span>
            </div>
            <div className="p-6">
              <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-teak">{cat.tagline}</p>
              <h3 className="mt-2 font-serif text-xl text-walnut">{cat.name}</h3>
              <p className="mt-2 text-sm leading-relaxed text-stone-600">{cat.desc}</p>
              <button
                data-testid={`category-view-${cat.id}`}
                onClick={() => filterShowcase(cat.name)}
                className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-walnut underline decoration-brass decoration-2 underline-offset-4 transition-colors hover:text-teak"
              >
                View Products
                <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </button>
            </div>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
